import React, { Component, forwardRef } from 'react';
import MaterialTable from 'material-table';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Form from 'react-bootstrap/Form';
import 'rodal/lib/rodal.css';
import Paper from '@material-ui/core/Paper';
import { Redirect } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import Edit from '@material-ui/icons/Edit';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import { LocalizationTheme } from '../../../../utils/utils.js';
import { sortTableStringsNotCaseSensitive } from '../../../../utils/tableSorting.js';
import appFetch from '../../../../api/appFetch.js';
import { BookingWaitSlotsUrl } from '../../../../constants/apiUrls.js';
import OutletsDropdown from '../../../Common/Dropdowns/OutletsDropdown.js';

const tableIcons = {
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
};

export default class OutletWaitSlotsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataGrid: [],
            outletId: this.props.outletId ?? 0,
            fetchingData: true,
            data: [],
        };
        this.DaysNames = [this.props.resources["Sunday"], this.props.resources["Monday"], this.props.resources["Tuesday"],
        this.props.resources["Wednesday"], this.props.resources["Thursday"], this.props.resources["Friday"], this.props.resources["Saturday"]];
    }

    componentWillReceiveProps(newProps) {
        if (newProps.refreshGrid) {
            this.setState({ outletId: newProps.outletId !== undefined ? newProps.outletId : this.props.outletId });
            this.getBookingWaitSlots();
        }

        this.setState({ redirect: null });
    }

    componentDidMount() {
        this.getBookingWaitSlots();
    }

    handleChangeOutlet = e => {
        var moboOutletDesc = this.props.accessibleMoboOutlets.find(o => o.id === e.target.value)?.description ?? "-";
        this.setState({ outletId: e.target.selectedIndex === 0 ? 0 : e.target.value, outletDescription: moboOutletDesc }, () => this.getTableData(this.state.outletId));
    };

    getBookingWaitSlots = () => {
        this.setState({ fetchingData: true, data: [] });

        appFetch({
            url: BookingWaitSlotsUrl(),
            onSuccess: (data) => {
                const currentRows = data
                    .sort((x, y) => x.slotHour > y.slotHour ? 1 : -1)
                    .reduce((outletsData, currentWaitSlot) => {
                        const id = currentWaitSlot.moboOutlet.moboOutletId;
                        const day = currentWaitSlot.slotDay;
                        const hour = currentWaitSlot.slotHour;
                        const isForNonWaitingCustomers = currentWaitSlot.isForNonWaitingCustomers;

                        if (!outletsData[id]) {
                            outletsData[id] = {
                                outletId: id,
                                waitSlots: [[], [], [], [], [], [], []]
                            }
                        }

                        outletsData[id].waitSlots[day].push(
                            {
                                slotHour: hour,
                                numberOfSlots: currentWaitSlot.numberOfSlots,
                                slotId: currentWaitSlot.id,
                                isForNonWaitingCustomers: isForNonWaitingCustomers
                            });
                        return outletsData;
                    }, {})

                this.setState({
                    data: currentRows,
                    fetchingData: false
                });

                this.getTableData(this.state.outletId);
            },
            onError: (data) => {

            },
            onFinalize: () => {
                this.setState({ fetchingData: false });
            }
        })
    }

    getTableData = (outletId) => {
        const { accessibleMoboOutlets } = this.props;

        if (outletId === undefined || outletId === 0) {
            if (accessibleMoboOutlets === undefined) {
                return;
            }
            outletId = null;
        }

        this.setState({ fetchingData: true });

        let initialData = {};
        var resources = this.props.resources;
        initialData.columns = [
            {
                title: "",
                width: "5%",
            }, // added for spacing
            {
                title: resources["Day"],
                field: 'day',
                width: "30%",
                sorting: false
            },
            {
                title: resources["Hours"],
                field: 'hours',
                width: "60%",
                customSort: (a, b) => sortTableStringsNotCaseSensitive(a.hours, b.hours)
            },
        ];

        initialData.actions = [
            {
                icon: () => <Edit />,
                tooltip: resources["Edit"],
                onClick: (event, rowData) => this.setState({ redirect: `bookingwaitslots/${this.state.outletId}`, day: rowData.day })
            }
        ];

        if (outletId > 0) {
            var tableData = this.state.data[outletId]?.waitSlots.map((slotData, index) => {
                return { day: this.DaysNames[index], hours: slotData.length > 0 ? slotData.map(x => x.slotHour).join(", ") : "-" }
            }) ?? this.DaysNames.map((day, index) => { return { day: this.DaysNames[index], hours: "-" } });

            initialData.data = tableData;
        }

        this.setState({
            dataGrid: initialData,
            fetchingData: false
        });

    }

    render() {
        const { redirect, fetchingData, outletId } = this.state;
        const { resources } = this.props;

        if (redirect) {
            const dayId = this.DaysNames.indexOf(this.state.day);

            return <Redirect to={{
                pathname: redirect,
                state: { outletId: this.state.outletId, dayId, waitSlots: this.state.data[outletId]?.waitSlots[dayId] ?? [] },
            }}
            />
        }

        return <div>
            <div className="position-relative py-4">
                <h3>{resources["WaitOnPremiseCapacity"]}</h3>
                <div className={"offcentered-loader " + (fetchingData ? 'fadeIn' : 'fadeOut')}><CircularProgress /></div>
                <div className={"mt-4 " + (fetchingData ? 'fadeOut' : 'fadeIn')}>
                    <Form.Group className="main-dropdown">
                        <OutletsDropdown
                            resources={resources}
                            outlets={this.props.accessibleMoboOutlets}
                            outlet={outletId}
                            onOutletChange={this.handleChangeOutlet}
                            containerClass="col-md-12"
                            id="outlet-dropdown-grid"
                            defaultValue={resources["SelectOutlet"]}
                        />
                    </Form.Group>

                    <div style={{ clear: "both", }}></div>

                    <Paper elevation={3} className="p-3 mt-3">
                        <MuiThemeProvider theme={LocalizationTheme()}>
                            <MaterialTable
                                icons={tableIcons}
                                title={""}
                                localization={{
                                    header: { actions: resources["Actions"] },
                                    body: {
                                        emptyDataSourceMessage: resources["NoRecordsToBeDisplayed"],
                                        editTooltip: resources["EditTooltip"],
                                    }
                                }}
                                data={this.state.dataGrid.data}
                                columns={this.state.dataGrid.columns}
                                actions={this.state.dataGrid.actions}
                                options={{ emptyRowsWhenPaging: false, pageSize: 7, filtering: false, search: false, debounceInterval: 700, paging: false }}
                            />
                        </MuiThemeProvider>
                    </Paper>
                </div>
            </div>

        </div>
    }

}